import React from 'react';

import { useTranslation } from 'react-i18next';
import evaluateReferral from 'src/assets/img/evaluteReferral.svg';
import memory from 'src/assets/img/memory.svg';
import referral from 'src/assets/img/referral.svg';
import services from 'src/assets/img/services.svg';

const HowTo: React.FC = () => {
  const { t: tOneWayIn } = useTranslation('oneWayIn');

  return (
    <div className="stack-large">
      <h2>{tOneWayIn('frontpage.howTo.header')}</h2>
      <div className="stack-medium">
        <img className="margin-x--auto display--block" alt="hei" src={evaluateReferral}></img>
        <h3 className="font-weight--bold">{tOneWayIn('frontpage.howTo.evaluateReferral.header')}</h3>
        <p>{tOneWayIn('frontpage.howTo.evaluateReferral.text')}</p>
      </div>
      <div className="stack-medium">
        <img className="margin-x--auto display--block" alt="hei" src={referral}></img>
        <h3 className="font-weight--bold">{tOneWayIn('frontpage.howTo.referral.header')}</h3>
        <p>{tOneWayIn('frontpage.howTo.referral.text')}</p>
      </div>
      <div className="stack-medium">
        <img className="margin-x--auto display--block" alt="hei" src={services}></img>
        <h3 className="font-weight--bold">{tOneWayIn('frontpage.howTo.services.header')}</h3>
        <p>{tOneWayIn('frontpage.howTo.services.text')}</p>
      </div>
      <div className="stack-medium">
        <img className="margin-x--auto display--block" alt="hei" src={memory}></img>
        <h3 className="font-weight--bold">{tOneWayIn('frontpage.howTo.memory.header')}</h3>
        <p>{tOneWayIn('frontpage.howTo.memory.text')}</p>
      </div>
    </div>
  );
};

export default HowTo;
